/* @ngInject */
const field = (
  utils,
  $filter,
  valueHandler,
  wagonUtils,
  matcher
) => {
  return (_item, _ref = null) => {
    if (valueHandler.isEmpty(_item)) {
      return '-'
    }

    if (valueHandler.isString(_ref)) {
      if (matcher.containDate(_ref)) {
        if (utils.date.isValidTimestamp(_item)) {
          return utils.date.timestampToString(_item)
        } else if (utils.date.isValidString(_item)) {
          return _item
        } else if (utils.date.isValidDate(_item)) {
          return utils.date.dateToString(_item)
        }
      } else if (matcher.isWagonId(_ref)) {
        return wagonUtils.idToString(_item)
      } else if (matcher.containIntegerReference(_ref)) {
        if (_item.toString().match('[0-9]* - [0-9]*')) return _item
        return ($filter('number')(_item, 0)).toString().replace(',', ' ')
      } else if (matcher.containDecimalReference(_ref)) {
        return ($filter('number')(_item, 2)).toString().replace(',', ' ')
      }
    }

    if (matcher.isWagonId(_item)) {
      return wagonUtils.idToString(_item)
    }

    if (typeof (_item) === 'boolean') {
      return _item ? 'Oui' : 'Non'
    }

    return _item.toString()
  }
}

export default field



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/filters/entities/field.filter.js